/* use-largura-ate — se a janela está até `px` de largura (spec 0104). No molde
 * de `use-is-mobile.ts`, mas com o corte escolhido por quem chama: a casca
 * troca o menu para o celular abaixo de 901px, e não de 768px. */

import { useCallback, useSyncExternalStore } from "react"

function consulta(px: number): MediaQueryList | undefined {
  return typeof window === "undefined" ? undefined : window.matchMedia(`(max-width: ${px}px)`)
}

export function useLarguraAte(px: number): boolean {
  const assinar = useCallback(
    (avisar: () => void) => {
      const mql = consulta(px)
      mql?.addEventListener("change", avisar)
      return () => mql?.removeEventListener("change", avisar)
    },
    [px],
  )
  return useSyncExternalStore(
    assinar,
    () => consulta(px)?.matches ?? false,
    () => false,
  )
}
